export default "__VITE_ASSET__CUR5oulb__"